export default "__VITE_PUBLIC_ASSET__35d6d971__"